/**
 * @generated SignedSource<<530c01be2e0ee6375bab506f8a0a7172>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type VerticalType = "furniture" | "fashion" | "jewelry" | "art" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedIconBubblePinterest_item$data = {
  readonly title: string | null;
  readonly pdpURL: string | null;
  readonly vertical: VerticalType | null;
  readonly classification: {
    readonly categories: ReadonlyArray<{
      readonly precedence: number | null;
      readonly category: {
        readonly name: string | null;
        readonly browseUrl: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly photos: ReadonlyArray<{
    readonly largePath: string | null;
  } | null> | null;
  readonly " $fragmentType": "PdpSharedIconBubblePinterest_item";
};
export type PdpSharedIconBubblePinterest_item$key = {
  readonly " $data"?: PdpSharedIconBubblePinterest_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedIconBubblePinterest_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedIconBubblePinterest_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pdpURL",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vertical",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemClassification",
      "kind": "LinkedField",
      "name": "classification",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemCategory",
          "kind": "LinkedField",
          "name": "categories",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "precedence",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Category",
              "kind": "LinkedField",
              "name": "category",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "browseUrl",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "largePath",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "cd75d7bafc86af106241608205487438";

export default node;
